import React from "react";
import '../ServicesInfo/servicesInfo.css'


function SocialMediaOutreach(){
    return(
        <div id="social">
            <div className="row w-100 m-0">

                <div className="col-lg-6 background_lightGrey">
                    <div className="servicesBox_padding">
                        <h1 className="main_heading">03</h1>
                        <div className="bar rounded"></div>
                        <h2 className='main_heading titleFont_style py-2'>Social Media Outreach</h2>
                        <p className="text">
                            We leverage major social platforms to initiate conversations, build awareness, 
                            and drive engagement through direct and indirect outreach strategies.
                        </p>

                        <span className='span_Titles text-dark ' ><b>Platforms we support:</b></span>

                        <div className="caseList d-flex flex-wrap py-2">
                            <ul className="all_type_list p-0 pe-5">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Instagram </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> TikTok </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Facebook</li>
                            </ul>
                            <ul className="all_type_list p-0 ">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> YouTube </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Twitter (X) </li>
                            </ul>
                        </div>

                        <span className='span_Titles text-dark ' ><b>Our social outreach includes:</b></span>

                        <div className="caseList d-flex flex-wrap py-2">
                            <ul className="all_type_list p-0 pe-5">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Target audience research </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Direct message (DM) outreach strategies </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Comment and engagement-based prospecting </li>
                            </ul>
                            <ul className="all_type_list p-0 ">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Influencer and brand outreach (where applicable) </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Lead capture and follow-up workflows </li>
                            </ul>
                        </div>

                        <span className='span_Titles text-dark ' ><b>Best for:</b></span>

                        <p className="text">
                            Brand outreach, creator partnerships, community building, and modern lead acquisition.
                        </p>

                        <a href="/contact" target='_blank' className="btn blue_btn rounded">DISCUSS YOUR PROJECT <i class="fa-solid fa-arrow-right ms-2"></i> </a>
                    </div>
                </div>

                <div className="col-lg-6 p-0 bg-dark">
                    <div className="Col_bg social-outreach"></div>
                </div>
                
            </div>
        </div>
    )
}

export default SocialMediaOutreach;